import React from 'react'
import Markdown from 'react-markdown'

const StringMessage2 = (props) => {
  return <Markdown linkTarget={'_blank'}>{props.message.string}</Markdown>
}

export default StringMessage2
